import type { AgentThreadShareVo } from "@/api";
import { api } from "@/api";
import { isAxiosError } from "axios";
import { notFound } from "next/navigation";

export async function fetchSharedThread(threadId: string) {
  if (!threadId) {
    return null;
  }

  try {
    const response = await api.threads.getSharedThread(threadId);
    const thread = response.data ?? null;

    if (!thread?.id) {
      return null;
    }

    return thread as AgentThreadShareVo;
  } catch (err) {
    if (isAxiosError(err) && err.response?.status === 404) {
      notFound();
    }
    throw err;
  }
}
